import { memo } from 'react';

import { useShortIdContext } from '@air/provider-short-id';

import { AudioSampleRatesSelect } from '~/components/Filters/AudioSampleRateFilter/components/AudioSampleRatesSelect';
import { type BaseStringSelectProps } from '~/components/StringSelect';
import { usePublicAudioSampleRatesList } from '~/swr-hooks/filters/usePublicAudioSampleRatesList';

type PublicAudioSampleRatesSelectProps = {
  boardId: string | undefined;
} & BaseStringSelectProps;

export const PublicAudioSampleRatesSelect = memo(({ boardId, ...props }: PublicAudioSampleRatesSelectProps) => {
  const { shortId } = useShortIdContext();

  const { data = [], isLoading } = usePublicAudioSampleRatesList({
    shortId,
    boardId,
  });

  return <AudioSampleRatesSelect isLoading={isLoading} audioRates={data} {...props} />;
});

PublicAudioSampleRatesSelect.displayName = 'PublicAudioSampleRatesSelect';
